/**
 * Created by Nisarg on 9/6/2017.
 */
import React, {Component} from 'react';
import $ from 'jquery';
import SweetAlert from 'react-bootstrap-sweetalert';
import firebase from 'firebase';
import _HauteFirte from '../../Utils/HauteFire';

const HauteFire = new _HauteFirte();

export default class AllIslands extends Component {
    constructor() {
        super();

        this.state = {
            AllIslands: [],
            CopyAllIslands: [],
            deleteIslandId: "",
            deleteIslandImgUrl: "",
            deleteIslandName: "",
            sweetAlertDelete: null,
            sweetAlertOrder: null,
            orderIslandImgUrl: "",
            orderIslandName: "",
            isOrderChangeMode: false,
            previouslyIslandOrderElem: {},
            fromIslandOrderChange: "",
            toIslandOrderChange: ""
        }
    }

    componentDidMount() {
        const _this = this;
        let islandRef = firebase.database().ref('IslandDetails');
        islandRef.on('value', (response) => {
            let AllIslands = response.val();
            if (AllIslands != null) {
                const keys = Object.keys(AllIslands);
                AllIslands = keys.map((key) => {
                    return AllIslands[key]
                });
                if (AllIslands.length > 0) {
                    AllIslands = AllIslands.sort((a, b) => {
                        return a.order - b.order
                    });

                    _this.setState({AllIslands, CopyAllIslands: AllIslands});
                }
            }
        })

        $(document).on("click", "li.filter", this.filterCategories.bind(this));
        $(document).on("drop", "div.divIslandDraggable", this.dropIslandDiv.bind(this));
        $(document).on("dragover", "div.divIslandDraggable", this.dragOverIslandDiv.bind(this));
        $(document).on("dragstart", "div.divIslandDraggable", this.dragStartIslandDiv.bind(this));
        // $(document).on("click", "a.btnDeleteIsland", this.showDeletePopup.bind(this));
        $(document).on("click", "a.btnGoToIsland", this.goToIsland.bind(this));
        $(document).on("keyup", ".txtIslandOrder", this.changeIslandOrder.bind(this));
        $(document).on("dblclick", ".lblIslandOrder", this.makeTxtOrder.bind(this));
    }

    makeTxtOrder(e) {
        const {isOrderChangeMode} = this.state;
        if (!isOrderChangeMode) {
            const islandId = $(e.currentTarget).attr("data-islandId");
            const islandOrder = $(e.currentTarget).attr("data-islandOrder");
            let currentHtmlParent = $(e.currentTarget).parent("p")[0];
            let currentHtml = e.currentTarget;  //$("<div id='divTemp'>").append(e.currentTarget).append("</div>").html();
            if (((currentHtml && currentHtmlParent) != undefined) && ((islandId && islandOrder) != "")) {
                $(currentHtmlParent).html("<input type='number' min='1' max=" + this.state.AllIslands.length + " class='txtIslandOrder' data-islandId=" + islandId + " data-islandOrder=" + islandOrder + " value=" + islandOrder + " style='width:40px' />");

                this.setState({isOrderChangeMode: true, previouslyIslandOrderElem: currentHtml});
            }
        }
    }

    changeIslandOrder(e) {
        if (e.keyCode == 13) {
            let requiredOrder = e.currentTarget.value;
            const {previouslyIslandOrderElem} = this.state;
            if (requiredOrder != "" && previouslyIslandOrderElem != {}) {
                const currentOrder = previouslyIslandOrderElem.attributes["data-islandOrder"].value;
                if (requiredOrder != currentOrder) {
                    const requiredIsland = this.state.AllIslands.filter((island) => {
                        return island.order == requiredOrder
                    })[0];
                    if (requiredIsland != undefined) {
                        const fromIslandOrderChange = this.state.previouslyIslandOrderElem.attributes["data-islandId"].value;
                        const toIslandOrderChange = requiredIsland.id;
                        let orderIslandImgUrl = "";
                        if (requiredIsland.islandPics.hasOwnProperty('bannerPic')) {
                            orderIslandImgUrl = requiredIsland.islandPics.bannerPic.url;
                        }

                        const sweetAlertOrder = () => (
                            <SweetAlert
                                warning
                                showCancel
                                confirmBtnText="Yes. replace it"
                                confirmBtnBsStyle="warning"
                                cancelBtnBsStyle="default"
                                title={orderIslandImgUrl != "" ?
                                    <img src={orderIslandImgUrl} style={{width: 300, height: 200}}/> :
                                    <span>Replace</span>}
                                onCancel={this.hideOrderPopup.bind(this)}
                                onConfirm={this.confirmOrderChange.bind(this)}
                            >
                                <strong>You want to replace order with {requiredIsland.name}?</strong>
                            </SweetAlert>
                        );

                        this.setState({fromIslandOrderChange, toIslandOrderChange, sweetAlertOrder: sweetAlertOrder()});
                    }
                }
                else {
                    this.hideOrderPopup(e);
                }
            }
        }
    }

    confirmOrderChange(e) {
        const {fromIslandOrderChange, toIslandOrderChange} = this.state;
        if ((fromIslandOrderChange && toIslandOrderChange) != "") {
            let {AllIslands} = this.state;
            let islands = AllIslands.filter((island) => {
                return ((island.id == fromIslandOrderChange || island.id == toIslandOrderChange))
            });
            if (islands.length == 2) {
                let fromIsland = islands[0];
                let toIsland = islands[1];
                const fromIslandOrder = fromIsland.order;
                const toIslandOrder = toIsland.order;
                fromIsland.order = toIslandOrder;
                toIsland.order = fromIslandOrder;

                AllIslands = AllIslands.sort((a, b) => {
                    return a.order - b.order
                });

                this.updateIslandOrder(fromIsland.id, fromIsland.order);
                this.updateIslandOrder(toIsland.id, toIsland.order);

                this.setState({AllIslands});
                this.hideOrderPopup(e);
            }
        }
    }

    updateIslandOrder(islandId, islandOrder) {
        firebase.database().ref('/IslandDetails/' + islandId + '/').update({'order': islandOrder});
    }

    goToIsland(e) {
        const islandId = e.currentTarget.attributes["data-islandId"].value;
        if (islandId != undefined) {
            this.props.history.push("/islands/addisland/" + islandId);
        }
    }

    hideOrderPopup(e) {
        let {previouslyIslandOrderElem} = this.state;
        if (previouslyIslandOrderElem != undefined) {
            const islandId = previouslyIslandOrderElem.attributes["data-islandId"].value;
            if (islandId != (undefined || "")) {
                $("#p" + islandId).html(previouslyIslandOrderElem);
            }
        }

        this.setState({
            sweetAlertOrder: null,
            fromIslandOrderChange: "",
            toIslandOrderChange: "",
            orderIslandImgUrl: "",
            orderIslandName: "",
            isOrderChangeMode: false,
            previouslyIslandOrderElem: {}
        });
    }

    hideDeletePopup(e) {
        this.setState({
            sweetAlertDelete: null, deleteIslandId: "",
            deleteIslandImgUrl: "",
            deleteIslandName: ""
        });
    }

    confirmPopup(e) {

    }

    showDeletePopup(e) {
        const deleteIslandId = e.currentTarget.attributes["data-islandId"].value;
        if (deleteIslandId != undefined) {
            const island = this.state.CopyAllIslands.filter((island) => {
                return island.id == deleteIslandId
            })[0];
            if (island != undefined) {
                const deleteIslandName = island.name;
                let deleteIslandImgUrl = "";
                if (island.hasOwnProperty('islandPics') && island.islandPics.hasOwnProperty('bannerPic')) {
                    deleteIslandImgUrl = island.islandPics.bannerPic.url;
                }
                const sweetAlertDelete = () => (
                    <SweetAlert
                        warning
                        showCancel
                        confirmBtnText="Yes. delete it"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title={deleteIslandImgUrl != "" ?
                            <img src={deleteIslandImgUrl} style={{width: 300, height: 200}}/> :
                            <span>Are you sure?</span>}
                        roomId={deleteIslandId}
                        onCancel={this.hideDeletePopup.bind(this)}
                        onConfirm={this.confirmPopup.bind(this)}
                    >
                        <strong>You want to delete {deleteIslandName} ?</strong>
                    </SweetAlert>
                );

                this.setState({deleteIslandId, deleteIslandName, sweetAlertDelete: sweetAlertDelete()});
            }
        }
    }

    dropIslandDiv(e) {
        e.preventDefault();
        const senderIslandId = e.originalEvent.dataTransfer.getData("islandId");
        const receiverIslandId = e.currentTarget.attributes["data-islandId"].value;
        let AllIslands = this.state.AllIslands;
        const islands = AllIslands.filter((island) => {
            return (island.id == senderIslandId || island.id == receiverIslandId)
        });
        if (islands.length == 2) {
            let senderIsland = islands[0];
            let receiverIsland = islands[1];
            const senderIslandOrder = senderIsland.order;
            const receiverIslandOrder = receiverIsland.order;

            senderIsland.order = receiverIslandOrder;
            receiverIsland.order = senderIslandOrder;

            AllIslands = AllIslands.sort((a, b) => {
                return a.order - b.order
            });

            let {CopyAllIslands} = this.state;
            for (let i = 0; i < CopyAllIslands.length; i++) {
                let matchedIsland = AllIslands.filter((island) => {
                    return island.id == CopyAllIslands[i].id
                })[0];
                if (matchedIsland != undefined) {
                    CopyAllIslands[i] = matchedIsland;
                }
            }

            this.setState({AllIslands, CopyAllIslands});
        }
    }

    dragOverIslandDiv(e) {
        e.preventDefault();
    }

    dragStartIslandDiv(e) {
        const islandId = e.currentTarget.attributes["data-islandId"].value;
        if (islandId != undefined) {
            e.originalEvent.dataTransfer.setData("islandId", islandId);
        }
    }

    filterCategories(e) {
        $("li.filter").removeClass("active");
        $(e.currentTarget).addClass("active");
        const filterCategory = $(e.currentTarget).attr("data-filter").trim().toLowerCase();
        let {CopyAllIslands} = this.state;
        CopyAllIslands = CopyAllIslands.sort((a, b) => {
            return a.order - b.order
        });
        if (filterCategory != "all") {
            const categoryIslands = CopyAllIslands.map((island) => {
                let islandCat = island.category.filter((cat) => {
                    return cat.name.trim().toLowerCase() == filterCategory
                })[0];
                if (islandCat != undefined) {
                    return island;
                }
            }).filter((island) => {
                return island != undefined
            });
            if (categoryIslands.length > 0) {
                this.setState({AllIslands: categoryIslands});
            }
        }
        else {
            this.setState({AllIslands: this.state.CopyAllIslands});
        }
    }

    renderAllIslands(island) {
        let bannerPic = "";
        if (island.hasOwnProperty('islandPics') && island.islandPics.hasOwnProperty('bannerPic')) {
            bannerPic = island.islandPics.bannerPic.url;
        }

        return (<div className="divIslandDraggable col-lg-4 col-sm-4 col-xs-12 text-center mix wdesign mdia mix_all"
                     key={island.id} draggable="true" data-islandId={island.id}
                     style={{display: 'inline-block', opacity: '1'}}>
            <div className="folioImg2" style={{height: 200, marginTop: 30}}>
                <img className="preset"
                     src={bannerPic} alt={island.name}/>
                <div className="folioHover2">
                    <a className="preset prePhoto2 btnGoToIsland" title="Go" data-islandId={island.id}><i
                        className="fa fa-pencil-square-o"
                        aria-hidden="true"></i></a>
                    <a className="preset detailsLink2 btnDeleteIsland" data-islandId={island.id} title="Delete"><i
                        className="fa fa-trash" aria-hidden="true"
                        style={{color: 'white'}}></i></a>
                </div>
            </div>
            <div className="portfolioDetails">
                <h3 className="preset"><a className="preset btnGoToIsland" data-islandId={island.id}
                                          style={{cursor: 'pointer'}}>{island.name}</a>
                </h3>
                <p id={"p" + island.id} className="preset potCategory">
                    {/* <input className="txtIslandOrder" data-islandId={island.id} type="text" defaultValue={island.order}
                     style={{width:50}}/> */}
                    <strong className="lblIslandOrder" data-islandId={island.id}
                            data-islandOrder={island.order}>{island.order}</strong>
                </p>

            </div>
        </div>)
    }

    render() {
        return (<section className="portfolioArea commonSection folioPage2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 col-xs-12 wow fadeInUp animated" data-wow-duration="700ms"
                             data-wow-delay="300ms"
                             style={{
                                 visibility: 'visible',
                                 animationDuration: '700ms',
                                 animationDelay: '300ms',
                                 animationName: 'fadeInUp'
                             }}>
                            <ul className="preset folioBtn text-center">
                                <li className="preset filter active" data-filter="all">All</li>
                                <li className="preset filter" data-filter="Private">Private</li>
                                <li className="preset filter" data-filter="Romance">Romance</li>
                                <li className="preset filter" data-filter="Party">Party</li>
                                <li className="preset filter" data-filter="Family">Family</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div id="mixer">

                            {this.state.AllIslands.length > 0 ? this.state.AllIslands.map((island) => {
                                return this.renderAllIslands(island)
                            }) : ""}

                        </div>
                    </div>
                </div>

                {this.state.sweetAlertDelete}
                {this.state.sweetAlertOrder}
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/IslandManagement/AllIslands/AllIslands.js